'use client';

import ProgramHero from './ProgramHero';
import ProgramOverview from './ProgramOverview';
import CurriculumSection from './CurriculumSection';
import InstructorProfiles from './InstructorProfiles';
import ProjectShowcase from './ProjectShowcase';
import SuccessStories from './SuccessStories';
import PricingEnrollment from './PricingEnrollment';
import FAQSection from './FAQSection';

interface ProgramData {
  program: {
    title: string;
    tagline: string;
    duration: string;
    level: string;
    enrolledStudents: number;
    rating: number;
    heroImage: string;
    heroImageAlt: string;
  };
  highlights: Array<{
    icon: string;
    title: string;
    description: string;
  }>;
  description: string;
  modules: Array<{
    id: number;
    title: string;
    description: string;
    duration: string;
    lessons: Array<{
      title: string;
      duration: string;
      type: string;
    }>;
  }>;
  instructors: Array<{
    name: string;
    title: string;
    company: string;
    image: string;
    imageAlt: string;
    bio: string;
    experience: string;
    linkedin: string;
  }>;
  projects: Array<{
    title: string;
    description: string;
    image: string;
    imageAlt: string;
    technologies: string[];
    difficulty: string;
  }>;
  stories: Array<{
    name: string;
    image: string;
    imageAlt: string;
    previousRole: string;
    currentRole: string;
    company: string;
    salaryIncrease: string;
    testimonial: string;
    completionDate: string;
  }>;
  pricingOptions: Array<{
    name: string;
    price: string;
    duration: string;
    features: string[];
    popular?: boolean;
  }>;
  nextCohortDate: string;
  faqs: Array<{
    question: string;
    answer: string;
  }>;
}

interface ProgramInteractiveProps {
  data: ProgramData;
}

export default function ProgramInteractive({ data }: ProgramInteractiveProps) {
  return (
    <>
      <ProgramHero program={data.program} />
      <ProgramOverview highlights={data.highlights} description={data.description} />
      <CurriculumSection modules={data.modules} />
      <InstructorProfiles instructors={data.instructors} />
      {/* <ProjectShowcase projects={data.projects} /> */}
      {/* <SuccessStories stories={data.stories} /> */}
      {/* <PricingEnrollment pricingOptions={data.pricingOptions} nextCohortDate={data.nextCohortDate} /> */}
      <FAQSection faqs={data.faqs} />
    </>
  );
}